import React, { useState, useEffect, useMemo, useRef } from "react";
import "./Track-order.css";
import "../../assets/css/modal.css";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { trackOrder } from "../../actions/productActions";
import SingleOrder from "./SingleOrder";
import OrderLoader from "../../common/OrderLoader";
import image4 from "../../assets/images/trackorder.jpg";
import Pusher from "pusher-js";
import {
  OWN_DELIVERY_EVENT,
  ownDeliveryChannelName,
  readOwnDeliveryTransactionId,
  isOwnDeliveryOrder,
  shouldApplyOwnDeliveryEvent,
  applyOwnDeliveryEvent
} from "../../utils/deliveryMode";
//import Pagination from "rc-pagination";
//import "rc-pagination/assets/index.css";

//LALAMOVE KEEPS THE ORIGINAL PUSHER APP (PUBLIC test-channel)
const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER || "ap1";

//OWN DELIVERY BROADCASTS FROM A DIFFERENT PUSHER APP, SO IT NEEDS ITS OWN KEY + CLUSTER
const OWN_DELIVERY_PUSHER_KEY = process.env.REACT_APP_OWN_DELIVERY_PUSHER_KEY;
const OWN_DELIVERY_PUSHER_CLUSTER =
  process.env.REACT_APP_OWN_DELIVERY_PUSHER_CLUSTER || "ap2";

// DEL-4 :: private channels are authorised by the backend's own custom endpoint
// (not Laravel's default /broadcasting/auth), which additionally requires the
// customer's current business_id, location_id, and contact_id in the request body.
const PUSHER_AUTH_ENDPOINT =
  process.env.REACT_APP_PUSHER_AUTH_ENDPOINT ||
  `${(process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "")}/delivery/broadcast_auth`;

const readAuthToken = () => {
  try {
    return JSON.parse(localStorage.getItem("headers"))?.data?.token || null;
  } catch (err) {
    return null;
  }
};

//SAME localStorage.headers SHAPE THE REST OF THE APP READS contact_id FROM (e.g. productActions.js)
const readContactId = () => {
  try {
    return JSON.parse(localStorage.getItem("headers"))?.data?.user?.contact_id ?? null;
  } catch (err) {
    return null;
  }
};

// Read fresh on every auth request (via paramsProvider below) rather than once at
// subscribe time, so a business/location switch - or a different logged-in user -
// while the tab stays open is picked up immediately instead of authorising against
// whatever was active on mount.
const readOwnDeliveryAuthParams = () => ({
  business_id: localStorage.getItem("business_id"),
  location_id: localStorage.getItem("location_id"),
  contact_id: readContactId(),
});

const TrackOrder = (props) => {
  const [page, setPage] = useState(1);
  const [orders, setOrders] = useState([]);
  //const elements = [] 
  const [hasPickUpOrder, setHasPickUpOrder] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const limit = 5;
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);


  const debouncedSearch = useDebounce(searchValue, 800);



  // Debounce function
  function useDebounce(value, delay = 800) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debouncedValue;
  }

  // Fetch orders
  useEffect(() => {
    let ignore = false;
    setIsFetching(true); // local loader

    // Only show global loader for first page
    const useGlobalLoader = false;

    props
      .trackOrder(page, limit, debouncedSearch || "", useGlobalLoader)
      .then((response) => {
        if (ignore) return;
        const newOrders = response?.data?.sells || [];

        if (newOrders.length < limit) setHasMore(false);

        setOrders((prevOrders) =>
          page === 1 ? newOrders : [...prevOrders, ...newOrders]
        );

        setIsFetching(false);
      })
      .catch(() => setIsFetching(false));

    return () => {
      ignore = true;
    };
  }, [page, debouncedSearch]);

  // Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      if (isFetching || !hasMore) return;

      if (
        window.innerHeight + document.documentElement.scrollTop + 100 >=
        document.documentElement.offsetHeight
      ) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, hasMore]);

  // Reset orders on new search
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setOrders([]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [debouncedSearch]);

  // Render orders
  let elements;
  if (isFetching && page === 1 && orders.length === 0) {
    // Show loader on first load
    elements = (
      <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
        }}
      >
        <div>
          <OrderLoader />
        </div>


      </div>
    );
  } else if (orders.length > 0) {
    // Show orders
    elements = orders.map((order, i) => {
      if (!hasPickUpOrder && order?.type_for_api !== "Delivery") {
        setHasPickUpOrder(true);
      }
      return (
        <SingleOrder
          key={order.id || i}
          order={order}
          cartDetails={props.getCartDetails}
        />
      );
    });
  } else {
    // Show no orders message
    elements = (
      <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
        }}
      >
        <img
          src="https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f6d2.svg"
          alt="No orders"
          style={{ width: "160px", height: "160px", marginBottom: "24px", opacity: 0.85 }}
        />
        <h4 style={{ color: "#2a2a2a", fontWeight: 700, marginBottom: "8px" }}>
          No Orders Yet
        </h4>
        <p style={{ color: "#9a9a9a", fontSize: "15px", maxWidth: "280px" }}>
          No pending order at this moment. Your orders will appear here once placed.
        </p>
      </div>
    );
  }

  useEffect(() => {
    if (!PUSHER_KEY) return; //NOTHING TO CONNECT TO WITHOUT A KEY
    const pusher = new Pusher(PUSHER_KEY, {
      cluster: PUSHER_CLUSTER,
      forceTLS: true
    });

    const channel = pusher.subscribe("test-channel");

    channel.bind("test-event", function (data) {
      console.log("Pusher Update Received in TrackOrder:", data);

      if (
        data?.message &&
        localStorage.getItem("location_id") === String(data.location_id) &&
        localStorage.getItem("business_id") === String(data.business_id)
      ) {
        console.log("Checking orders for ID:", data.order_id);

        setOrders(prevOrders => {
          const orderIndex = prevOrders.findIndex(
            order => String(order.id) === String(data.id)
          );

          if (orderIndex !== -1) {
            console.log("✅ Found order at index:", orderIndex);

            const updatedOrders = [...prevOrders];
            updatedOrders[orderIndex] = {
              ...updatedOrders[orderIndex],
              lalamove_status: data.status || updatedOrders[orderIndex].lalamove_status,
              estimated_arrival_time: data.estimated_arrival_time || updatedOrders[orderIndex].estimated_arrival_time,
              lalamove_driver_info: data.driver_info || updatedOrders[orderIndex].lalamove_driver_info,
              d_address: data.d_address || updatedOrders[orderIndex].d_address,
              paymentType: data.paymentType || updatedOrders[orderIndex].paymentType,
              card_type: data.card_type || updatedOrders[orderIndex].card_type,
              last_4_card_digits: data.last_4_card_digits || updatedOrders[orderIndex].last_4_card_digits,
              business_location_mobile_for_delivery: data.business_location_mobile_for_delivery || updatedOrders[orderIndex].business_location_mobile_for_delivery,
              pickup_completed: data.pickup_completed !== undefined ? data.pickup_completed : updatedOrders[orderIndex].pickup_completed,
              //DEL-3 :: KEEPS THE OWN DELIVERY STEPPER LIVE. FALLS BACK TO WHAT WE ALREADY HAVE WHEN THE EVENT OMITS IT
              delivery_mode: data.delivery_mode || updatedOrders[orderIndex].delivery_mode,
              delivery_status_histories: data.delivery_status_histories || updatedOrders[orderIndex].delivery_status_histories,
            };

            return updatedOrders;
          } else {
            console.log("Order not found in current page");
            return prevOrders;
          }
        });
      }
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe("test-channel");
      pusher.disconnect();
    };
  }, []);

  // DEL-4 :: OWN DELIVERY REALTIME
  // One private channel per own-delivery order on screen. Kept on its own Pusher
  // connection so the Lalamove channel above is unaffected by private-channel auth.
  // The list fetch above stays exactly as it was - it remains the fallback whenever
  // realtime is unavailable (no key, auth refused, socket down).

  //LAST PAYLOAD APPLIED PER TRANSACTION, USED TO DROP DUPLICATE / OUT OF ORDER EVENTS
  const appliedEventsRef = useRef({});

  //STABLE KEY SO RE-SUBSCRIBING ONLY HAPPENS WHEN THE SET OF ORDERS ACTUALLY CHANGES
  const ownDeliveryTransactionIds = useMemo(
    () =>
      Array.from(
        new Set(
          orders
            .filter((order) => isOwnDeliveryOrder(order))
            .map((order) => readOwnDeliveryTransactionId(order))
            .filter(Boolean)
        )
      ),
    [orders]
  );
  const ownDeliveryChannelKey = ownDeliveryTransactionIds.join(",");

  useEffect(() => {
    const transactionIds = ownDeliveryChannelKey ? ownDeliveryChannelKey.split(",") : [];
    if (!OWN_DELIVERY_PUSHER_KEY || transactionIds.length === 0) return;

    const token = readAuthToken();
    if (!token) return; //PRIVATE CHANNELS CANNOT BE AUTHORISED WHILE LOGGED OUT

    const pusher = new Pusher(OWN_DELIVERY_PUSHER_KEY, {
      cluster: OWN_DELIVERY_PUSHER_CLUSTER,
      forceTLS: true,
      channelAuthorization: {
        endpoint: PUSHER_AUTH_ENDPOINT,
        headers: { Authorization: `Bearer ${token}` },
        //FUNCTION, NOT A STATIC OBJECT - RE-EVALUATED ON EVERY AUTH CALL SO business_id/location_id STAY CURRENT
        paramsProvider: readOwnDeliveryAuthParams
      }
    });

    const channels = transactionIds.map((transactionId) => {
      const channelName = ownDeliveryChannelName(transactionId);
      const channel = pusher.subscribe(channelName);

      //A REFUSED PRIVATE CHANNEL FAILS SILENTLY OTHERWISE - SURFACE IT SO IT CAN BE DIAGNOSED
      channel.bind("pusher:subscription_error", (status) => {
        console.warn(`Pusher: could not subscribe to ${channelName}`, status);
      });

      channel.bind(OWN_DELIVERY_EVENT, (data) => {
        //IGNORES ANYTHING THAT IS NOT THIS ORDER, AN UNKNOWN SCHEMA, OR ALREADY SEEN
        if (!shouldApplyOwnDeliveryEvent(data, transactionId, appliedEventsRef.current[transactionId])) {
          return;
        }
        appliedEventsRef.current[transactionId] = data;

        setOrders((prevOrders) => {
          const orderIndex = prevOrders.findIndex(
            (order) => readOwnDeliveryTransactionId(order) === String(transactionId)
          );
          if (orderIndex === -1) return prevOrders;

          const updatedOrders = [...prevOrders];
          updatedOrders[orderIndex] = applyOwnDeliveryEvent(updatedOrders[orderIndex], data);
          return updatedOrders;
        });
      });

      return channel;
    });

    return () => {
      channels.forEach((channel) => {
        channel.unbind_all();
        pusher.unsubscribe(channel.name);
      });
      pusher.disconnect();
    };
  }, [ownDeliveryChannelKey]);

  return (
    <div>
      {/* Search Bar */}
      <div className="search-bar-section">
        <div className="search-bar-layout">
          <input
            type="text"
            className="search-input"
            placeholder="Search order..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      {/* <Pagination
                className="custom-pagination"
                current={page}
                total={props.total_orders || 0}
                pageSize={5}
                onChange={(pageNumber) => setPage(pageNumber)}
              />
                showTotal={(total, range) => `Showing ${range[0]}–${range[1]} of ${total}`}
              />*/}

      {/* Orders */}
      {elements}

      {/* Bottom Loader for infinite scroll */}
      {page > 1 && isFetching && hasMore && (
        <div style={{ textAlign: "center" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div
              style={{
                // marginBottom: "10px",
                paddingTop: "50px",   // top padding
                paddingBottom: "30px", // smaller bottom padding
                paddingLeft: "0",
                paddingRight: "0",
                lineHeight: 0,
                height: "40px",
                width: "94%",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTop: '9px solid #e8e6e6ff',
              }}
            >
              <OrderLoader text="" color="#ff0000" size={60} />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

const mapStateToProps = (state) => ({
  order: state.products.track_order,
  total_orders: state.products.total_orders,
  loader: state.products.loader,
});

export default withTranslation()(
  connect(mapStateToProps, { trackOrder })(TrackOrder)
);